import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { environment } from "../../../consts";
import Header from "./Header";
import "./HeroSection.scss";
import { RightArrowSvg } from "../../../utils/Icons";

const HeroSection = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [typedText1, setTypedText1] = useState("");
  const [typedText2, setTypedText2] = useState("");
  const [mobileTypedText1, setMobileTypedText1] = useState("");
  const [mobileTypedText2, setMobileTypedText2] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Desktop typing effect for "Secure Your Future"
    const fullText1 = "Secure Your Future";
    let currentIndex1 = 0;

    // Mobile typing effect for "Secure Your Future With "
    const mobileFullText1 = "Secure Your Future With ";
    let mobileCurrentIndex1 = 0;

    const typeText1 = () => {
      if (currentIndex1 < fullText1.length) {
        setTypedText1(fullText1.slice(0, currentIndex1 + 1));
        currentIndex1++;
        setTimeout(typeText1, 100);
      } else {
        // After first text is complete, wait a bit then start typing second text
        setTimeout(() => {
          const fullText2 = "With EduBlock Pro";
          let currentIndex2 = 0;

          const typeText2 = () => {
            if (currentIndex2 < fullText2.length) {
              setTypedText2(fullText2.slice(0, currentIndex2 + 1));
              currentIndex2++;
              setTimeout(typeText2, 100);
            }
          };

          typeText2();
        }, 300);
      }
    };

    // Mobile typing function
    const typeMobileText1 = () => {
      if (mobileCurrentIndex1 < mobileFullText1.length) {
        setMobileTypedText1(mobileFullText1.slice(0, mobileCurrentIndex1 + 1));
        mobileCurrentIndex1++;
        setTimeout(typeMobileText1, 100);
      } else {
        // After mobile first text is complete, wait a bit then start typing second text
        setTimeout(() => {
          const mobileFullText2 = "EduBlock Pro";
          let mobileCurrentIndex2 = 0;

          const typeMobileText2 = () => {
            if (mobileCurrentIndex2 < mobileFullText2.length) {
              setMobileTypedText2(
                mobileFullText2.slice(0, mobileCurrentIndex2 + 1)
              );
              mobileCurrentIndex2++;
              setTimeout(typeMobileText2, 100);
            }
          };

          typeMobileText2();
        }, 300);
      }
    };

    // Start both desktop and mobile typing effects
    typeText1();
    typeMobileText1();
  }, []);

  return (
    <section className={`hero-section ${isScrolled ? "scrolled" : ""}`}>
      <Header isScrolled={isScrolled} windowWidth={windowWidth} />
      {/* Main Hero Content */}
      <div className="hero-content">
        <div className="hero-text p-40">
          <p className="hero-tagline">
            India's most trusted <br />
            <span className="yellow-text">
              {" "}
              blockchain-powered examination platform
            </span>
          </p>
          {/* Right Side - Benefits */}
          <div className="hero-right">
            <div className="benefits-list">
              <p className="benefit-item">Zero paper leaks</p>
              <p className="benefit-item">100% transparency</p>
              <p className="benefit-item">
                Complete security for students and institutions
              </p>
            </div>
          </div>
        </div>
        <div className="hero-content-wrapper">
          {/* Center - Headline */}
          <h1 className="hero-headline p-40">
            <span className="headline-part1">
              {typedText1 ? (
                <>
                  {typedText1}
                  {typedText1.length < "Secure Your Future".length && (
                    <span className="typing-cursor">|</span>
                  )}
                </>
              ) : (
                <span className="typing-placeholder">Secure Your Future</span>
              )}
            </span>
            <span className="headline-part2">
              <span className="headline-part2-text">
                <span className="headline-part2-typed">
                  {typedText2 ? (
                    (() => {
                      const fullText2 = "With EduBlock Pro";
                      const yellowStartIndex = fullText2.indexOf("EduBlock");

                      if (typedText2.length <= yellowStartIndex) {
                        return (
                          <>
                            {typedText2}
                            <span className="typing-cursor">|</span>
                          </>
                        );
                      } else {
                        const beforeYellow = fullText2.slice(0, yellowStartIndex);
                        const yellowPart = typedText2.slice(yellowStartIndex);
                        return (
                          <>
                            {beforeYellow}
                            <span className="yellow-text">
                              {yellowPart}
                              {typedText2.length < fullText2.length && (
                                <span className="typing-cursor">|</span>
                              )}
                            </span>
                          </>
                        );
                      }
                    })()
                  ) : (
                    <span className="typing-placeholder">With EduBlock Pro</span>
                  )}
                </span>
                <span className="headline-part2-width-reserve" aria-hidden="true">
                  With EduBlock Pro
                </span>
              </span>
              {/* <Link
                to={environment.STUDENT_PORTAL ? `${environment.STUDENT_PORTAL}sign-up` : "/student/sign-up"}
                target="_blank"
                className="cta-button"
              >
                Candidate Registration
                <RightArrowSvg className="button-arrow" classNameArrow="button-arrow-arrow" />
              </Link> */}
            </span>
          </h1>
          <h1 className="hero-headline-mobile p-40">
            {mobileTypedText1 ? (
              <>
                {mobileTypedText1}
                {mobileTypedText1.length <
                  "Secure Your Future With ".length && (
                  <span className="typing-cursor">|</span>
                )}
              </>
            ) : (
              <span className="typing-placeholder">
                Secure Your Future With{" "}
              </span>
            )}
            <span>
              {mobileTypedText2 ? (
                <>
                  <span className="yellow-text">
                    {mobileTypedText2}
                    {mobileTypedText2.length < "EduBlock Pro".length && (
                      <span className="typing-cursor">|</span>
                    )}
                  </span>
                </>
              ) : (
                <span className="typing-placeholder yellow-text">
                  EduBlock Pro
                </span>
              )}
            </span>
            <Link
              to={environment.STUDENT_PORTAL ? `${environment.STUDENT_PORTAL}sign-up` : "/student/sign-up"}
              target="_blank"
              className="cta-button"
            >
              Candidate Registration
              <RightArrowSvg className="button-arrow" classNameArrow="button-arrow-arrow" />
            </Link>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
